import React, { useState } from 'react'
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import PropTypes from "prop-types";
import { Dropdown, Popup } from 'semantic-ui-react';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import './style.css'
import { isMobileOnly} from 'mobile-device-detect'
import {MonthYearPicker} from "./MonthYearPicker";
import { dateFormat, serverDateFormat } from '../constants';

export const DatePicker = ({onChange, value, picktype, clearable, tooltipContent, minRangeDays, startDate, ...rest})=>{

    // If minRangeDays is set and a startDate is provided, enforce minimum end date
    if (minRangeDays != null && startDate) {
        const computedMinDate = moment(startDate).add(minRangeDays, 'days').startOf('day').toDate();
        rest.minDate = rest.minDate
            ? (rest.minDate > computedMinDate ? rest.minDate : computedMinDate)
            : computedMinDate;
    }


    const onDateChange = (e, {value})=>{
        if (e && onChange){
            if(!value && !clearable){
                //do not allow date to be null if clearable is false
                return;
            }

            if(!value){
                onChange(null);
                return;
            }
            
            // Check if the date is an array (for range selection)
            if (Array.isArray(value)){
                const vals = value.map(val=> moment(val).format(serverDateFormat))
                onChange(vals)
                return;
            } else if (value){
                const val = moment(value).format(serverDateFormat)
                onChange(val)
            } else {
                onChange(null)
            }
        }
    }
    const userLang = window.optima?.user?.UserSettings[0]?.Language?.LocaleID;

    // Convert value to Date object if it's a valid string and not already a Date
    if (value && typeof value === "string") {
        const parsedDate = moment(value, serverDateFormat);
        if (parsedDate.isValid()) {
            value = parsedDate.toDate();
        }
    }

    // Convert value array items to Date objects if they are valid strings
    if (Array.isArray(value)) {
        value = value.map(val => {
            if (typeof val === "string") {
                const parsedDate = moment(val, serverDateFormat);
                if (parsedDate.isValid()) {
                    return parsedDate.toDate();
                }
            }
            return val;
        });
    }

    const datePicker = picktype === "month"? <MonthYearPicker onChange={onChange} clearable={clearable} {...rest}/>: <SemanticDatepicker
    format={rest.format || dateFormat}
    onChange={onDateChange}
    value={value}
    autoComplete="off"
    datePickerOnly={isMobileOnly}
    type={picktype}
    locale={userLang || document.documentElement.lang || 'he-IL'}
    clearable={clearable}
    {...rest}
/>

    return tooltipContent ? <Popup content={tooltipContent} trigger={datePicker} /> : datePicker
}

DatePicker.propTypes = {
    clearable: PropTypes.bool,
    picktype: PropTypes.string,
    onChange: PropTypes.func,
    tooltipContent: PropTypes.any,
    minRangeDays: PropTypes.number,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    value: PropTypes.oneOfType([PropTypes.string,PropTypes.arrayOf(PropTypes.string), PropTypes.instanceOf(Date),  PropTypes.arrayOf(PropTypes.instanceOf(Date))])
}

export const TimePicker = ({onChange, value ,step, clearable, ...rest})=>{
    const defaultStep = 15
    const s = step || defaultStep
    const range = moment.range('2000-01-01', '2000-01-02');
    const [acc, setAcc] = useState(Array.from(range.by('minute', { excludeEnd: true, step: s })))

    const onTimeChange = (e, {value})=>{
        if (onChange){
            onChange(value)
        }
    }

    const dateFormat = "HH:mm"
    const round = val=>{
        const rem = val.minute() % s;
        return rem?val.add(s-rem, "minutes"):val
    }
    const renderOptions = ()=>{
        const options = []
        if (clearable){
            options.push( {
                text: "None", 
                value: undefined,
                key: "none"
            })
        }
        return [...options, ...acc.map(val=>{
            return {
                text: val.format(dateFormat), 
                value: val.format(dateFormat),
                key: val.format(dateFormat)
            }})
        ]
    }

    return <Dropdown 
    onChange={onTimeChange} 
    search={false} allowAdditions={false} selection icon={{name: "time", link: true}} className='timepicker input icon' 
    options={renderOptions()} 
    onAddItem={(e, {value})=>setAcc([moment(value, dateFormat), ...acc])} 
    value={round(moment(value, moment.HTML5_FMT.TIME_SECONDS)).format(dateFormat)} {...rest}/>
}
 
TimePicker.propTypes = {
    step: PropTypes.number,
    onChange: PropTypes.func,
    value:PropTypes.string,
    clearable: PropTypes.bool,
}
